import _ from "lodash";
import moment from "moment";

export default {
    data() {
        return {
            duration: 'week',
        }
    },
    methods: {
        async buildData(data, keyName) {
            let result = [];
            _.forEach(data, (val, key) => {
                let totalCounts = _.reduce(val, (prev, current) => {

                    if (prev) {
                        if (current.value.constructor.name !== 'Object') {
                            current.value = parseFloat(prev) + parseFloat(current.value)
                        } else {
                            for (const property in current.value) {
                                current.value[property] = prev[property] + current.value[property]
                            }
                        }
                    }

                    return current.value
                }, 0)
                result.push({[keyName]: key, value: totalCounts})
            })
            return result;
        },
        async groupAndBuild(data, dateMethod, groupKey) {
            const newData = JSON.parse(JSON.stringify(data))

            newData.forEach(d => {
                d.dateObj = moment(d.date)
            });

            let groupedData = _.groupBy(newData, (d) => {
                if (dateMethod !== 'day') {
                    return d.dateObj.endOf(dateMethod).format('YYYY-MM-DD')
                }
                return d.dateObj.format('YYYY-MM-DD')
            })

            return await this.buildData(groupedData, groupKey)
        },
        tooltipFormatter(unix) {
            const date = moment.unix(unix / 1000)
            let label = date.clone().format("YYYY-MM-DD")

            if (this.duration !== 'day') {
                const start = date.clone().startOf(this.duration).format("YYYY-MM-DD")
                label = `${start} / ${label}`
            }
            return label
        },
        productReviewPercent(data) {
            const reviews = _.map(data, 'value')

            const sum = {
                negative: 0,
                positive: 0,
                neutral: 0
            }

            reviews.map(review => {
                sum.negative = sum.negative + review[1] + review[2]
                sum.positive = sum.positive + review[4] + review[5]
                sum.neutral = sum.neutral + review[3]
            })

            return sum
        }
    }
}